export default __webpack_public_path__ + "static/topdevelopers-d7bc8dd11de3ce4f208d7ec37221c6e5.svg";